module.exports = __webpack_public_path__ + "static/media/tick-white.e6fd6f4b.svg";